import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { FormulareService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [FormulareService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class FormulareServiceModule {}
